import React, { useEffect } from "react";
import "../../Informations/Information.css";
import nillimg from "../../../Assets/nillimg.jpeg";
import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

const OurMission = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <div className="page-main-container-aboutus">
        <div className="business-price-numbs">
          <div className="nill-img-text-hone">
            {/* <div className='nill-img-aboutus'>
                            <img src={nillimg} alt="" />
                        </div> */}
            <div>
              <h2 className="htwo-heading-aboutus">Building Trust in NIL</h2>
              <p className="text-aboutus">
                The NIL-Collab Platform Makes NIL Simple, Transparent, and Fair
              </p>

              <p className="text-aboutus">
                The NIL world is changing fast. Confusion, legal questions, and
                unclear deals can create doubt. NIL-Collab cuts through the
                noise. Transparency is at the core, giving athletes, fans, and
                brands confidence in every connection.
              </p>
            </div>
          </div>
          <div className="program-benefits-aboutus">
            <h3> 1. Clear Deals</h3>
            <p className="text-aboutus">
              Every partnership and sponsorship is fully visible. Athletes,
              fans, and brands can see how opportunities work. No surprises.
              Full clarity builds confidence.
            </p>
            <h3> 2. Compliance You Can Count On </h3>
            <p className="text-aboutus">
              All activities follow state and federal rules. Contracts,
              reporting, and requirements are tracked and verified. Everyone
              knows the rules are being followed.
            </p>
            <h3> 3. Equal Opportunity</h3>
            <p className="text-aboutus">
              Athletes from every school, every program, get a fair shot.
              Transparency ensures all athletes can access NIL opportunities.
              Trust grows when everyone plays on a level field.
            </p>
            <h3> 4. Fans and Supporters First</h3>
            <p className="text-aboutus">
              Fans and alumni want to see impact. Clear processes show how
              athletes’ benefit. Supporters feel connected, valued, and
              confident.
            </p>
            <h3> 5. Protecting Everyone</h3>
            <p className="text-aboutus">
              Clear tracking prevents conflicts. Athletes and brands operate
              with confidence, knowing everything is documented and accountable.
            </p>
          </div>
          <div className="program-benefits-aboutus">
            <h3> The NIL-Collab Difference</h3>

            <p className="text-aboutus">
              Transparency is the foundation of trust. NIL-Collab creates a
              platform where athletes grow, brands succeed, and fans engage with
              confidence. Simple. Clear. Fair.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OurMission;

// import React, { useEffect } from 'react'
// import "../../Informations/Information.css"
// import nillimg from "../../../Assets/nillimg.jpeg"
// import Footer from '../../Footer/Footer'
// import Header from '../../Header/Header'

// const OurMission = () => {
//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);
//     return (

//         <>
//             <Header />
//             <div className='page-main-container-aboutus'>
//                 <div className='business-price-numbs'>
//                     <div className='nill-img-text-hone'>
//                         {/* <div className='nill-img-aboutus'>
//                             <img src={nillimg} alt="" />
//                         </div> */}
//                         <div>
//                             <h2 className='htwo-heading-aboutus' >Building Trust in NIL (The purpose of the NIL-Collab platform)</h2>
//                             <p className='text-aboutus'>
//                                 As the NIL landscape continues to develop, legal uncertainties and confusion surrounding NIL deals are on the rise. In this shifting environment, transparency will be crucial for maintaining trust among athletes, supporters, and key stakeholders—including schools, businesses, and alumni. The NIL-Collab Platform is designed to deliver five core elements of transparency, helping to establish long-term credibility in this evolving market.
//                             </p>

//                         </div>
//                     </div>
//                     <div className='program-benefits-aboutus'>
//                         <h3> 1. Clear Tracking of Contributions and Deals</h3>
//                         <p className='text-aboutus'>
//                             With the potential for class-action lawsuits and individual claims, NIL-Collab provides full transparency in how contributions are distributed to athletes. This includes a clear breakdown of how much money an athlete receives, where it comes from (e.g., contributions from fans, local businesses, or alumni), and how the funds are used. Having this level of visibility could protect both athletes and supporters from any misunderstandings or legal issues down the line.
//                         </p>
//                         <h3> 2. Regulatory Compliance </h3>
//                         <p className='text-aboutus'>
//                             As more states enact their own laws around NIL, NIL-Collab demonstrates full compliance with these regulations. Transparency isn’t just about financial tracking but also about making sure all parties are abiding by the legal standards. This might include providing detailed reports about contracts, taxes, and other legal obligations to both athletes and contributors.
//                         </p>
//                         <h3> 3. Equal Opportunity for Athletes</h3>
//                         <p className='text-aboutus'>
//                             Transparency in how opportunities are distributed—whether a small-town athlete gets the same exposure and support as a big-market athlete—will help build credibility. If everyone sees that athletes from smaller programs or less-known schools are getting a fair shot at receiving NIL support, it could foster a stronger sense of community and support across all levels of college sports.
//                         </p>
//                         <h3> 4. Building Trust with Fans and Alumni</h3>
//                         <p className='text-aboutus'>
//                             In an era of social media and instant communication, any perceived lack of transparency can lead to distrust. Fans and alumni want to know where their money is going, and they want to feel like their support is making a real difference. Transparency ensures that everyone understands the process and can see the direct impact of their contributions on athletes’ lives and careers.
//                         </p>
//                         <h3> 5. Legal Protection and Avoiding Conflicts</h3>
//                         <p className='text-aboutus'>
//                             As lawsuits pile up, there’s the potential for disputes over how NIL funds are managed. By ensuring complete transparency, NIL-Collab will avoid legal complications that stem from accusations of mishandling funds or failing to provide athletes with their fair share.
//                         </p>

//                     </div>
//                     <div className='program-benefits-aboutus'>
//                         <p className='text-aboutus'>
//                             Ultimately, transparency helps NIL-Collab build a trusted system where athletes, fans, and businesses alike can navigate the rapidly changing landscape of NIL deals with confidence.
//                         </p>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </>
//     )
// }

// export default OurMission
